module.exports = __webpack_public_path__ + "img/customer-6.f26a4426.png";